import Vue from 'vue';
import VueI18n from 'vue-i18n';
import merge from 'lodash.merge';
import language from './language';

// element 语言包
import enLocale from 'irm-ui/lib/locale/lang/en';
import zhLocale from 'irm-ui/lib/locale/lang/zh-CN';

Vue.use(VueI18n);

export const EN = 'en';
export const ZH = 'zh-cn';

export const LANGUAGE_LIST = [ZH, EN];

export const defaultLanguage = 'ZH';



const CN_MSG = {
	...language[ZH],
	...merge(zhLocale, {
		'el': {
			'pagination': {
				'total': '共 {total} 条',
				'pagesize': '条/页',
				'goto': '前往',
				'pageClassifier': '页'
			}
		}
	})
};
const EN_MSG = {
	...language[EN],
	...merge(enLocale, {
		'el': {
			'pagination': {
				'total': 'A total of {total} ',
				'pagesize': '',
				'goto': 'Redirect',
				'pageClassifier': 'Pages'
			}
		}
	})
};


const i18n = new VueI18n({
	locale: defaultLanguage,
	fallbackLocale: defaultLanguage,
	messages: {
		[ZH]: CN_MSG,
		[EN]: EN_MSG,
	}
});
i18n.EN = EN;
i18n.ZH = ZH;


export function changeLocaleLang(lang) {
	const language =
		lang ||
		(/^\/([a-z_-]+)\//i.test(location.pathname) && RegExp.$1) ||
		window.sessionStorage.getItem('Language') ||
		navigator.language ||
		defaultLanguage;

	const langMap = { 'zh-cn': ZH, 'en': EN };
	const locale = langMap[language.toLowerCase()] || defaultLanguage;
	i18n.locale = locale;
}

changeLocaleLang();
console.log('-------------- i18n:', location.pathname);


export default i18n;